import { Button } from '@features/ui';
import { ExportIcon } from '@features/ui/icons';
import { PayoutsPaAnalysisByDateTable } from '@features/admin/reports';
import { useState } from 'react';
import { DateValueType, downloadFile } from '@lib/utils';
import { exportPaPayoutAnalysis } from '@src/services/reports';
import { format } from 'date-fns';

export const PayoutsPaAnalysisByDate = () => {
  const [valueStart, setValueStart] = useState<DateValueType>(null);
  const [valueEnd, setValueEnd] = useState<DateValueType>(null);
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    if (!valueStart?.startDate || !valueEnd?.startDate) {
      alert('Please select both start and end dates first');

      return;
    }

    try {
      setIsExporting(true);
      const fromDate = format(valueStart.startDate, 'yyyy-MM-dd');
      const toDate = format(valueEnd.startDate, 'yyyy-MM-dd');

      const response = await exportPaPayoutAnalysis({
        from_date: fromDate,
        to_date: toDate,
      });

      downloadFile(response.data, 'pa-payout-analysis');
    } catch (error) {
      console.error('Error exporting data:', error);
      alert('Failed to export data. Please try again.');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div>
      <div
        className={
          'flex justify-between lg:items-center gap-7.5 lg:flex-row flex-col'
        }
      >
        <div className={'text-xs flex lg:flex-row flex-col gap-x-8 gap-y-3'}>
          <h1 className={'text-[23px]'}>Payouts - PA Analysis by Date</h1>
        </div>
        <Button
          className={'h-9.5 border-1 border-[#C6C6C6] rounded-[3px] w-fit'}
          disabled={isExporting}
          variant={'outline'}
          onClick={handleExport}
        >
          <p>{isExporting ? 'Exporting...' : 'Export'}</p>
          <ExportIcon />
        </Button>
      </div>
      <PayoutsPaAnalysisByDateTable
        setValueEnd={setValueEnd}
        setValueStart={setValueStart}
        valueEnd={valueEnd}
        valueStart={valueStart}
      />
    </div>
  );
};
